import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

interface TextAreaEditorProps {
  value: string;
  onChange: (text: string) => void;
}

function TextAreaEditor({ value, onChange }: TextAreaEditorProps) {
  return (
    <Editor
      value={value ?? ''}
      apiKey={process.env.NEXT_PUBLIC_TINY_KEY}
      init={{
        height: 300,
        menubar: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'media',
          'image',
        ],
        toolbar: `undo redo | formatselect | bold italic forecolor backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help`,
      }}
      onEditorChange={(content) => onChange(content)}
    />
  );
}

export default TextAreaEditor;
